import React from "react";
import { Link } from "react-router-dom";
import Error from "./Assests/error.png";
import Plugin from "./Assests/error1.png";
import Topbar from "./components/Topbar/Topbar";
import Footer from "./components/footer/Footer";

function ErrorPage() {
  return (
    <section className="position-relative error-container">
      <Topbar />
      <section
        style={{
          backgroundImage: `linear-gradient(
      to right,
      rgba(58, 58, 58, 0.4),
      rgba(58, 58, 58, 0.4)
    ),url(${Error})`,
        }}
        className="error_section"
      >
        <div className="container error_container_inner">
          <div className="row">
            <div className="col-12 text-center mb-5">
              <h2 className="heading404">404</h2>
              <h3 className="subheading404">Page not found</h3>
              <p className="text-white">
                Please make sure you have entered the correct URL or try
                refreshing the page.
              </p>
              <Link to="/" className="text-white f-18 mt-3">
                <u>Go back to home page</u>
              </Link>
            </div>
          </div>
        </div>
      </section>
      <img src={Plugin} className="plugin" />
      <Footer />
    </section>
  );
}

export default ErrorPage;
